export default __webpack_public_path__ + "static/media/Prompt-Light.5ca60d5b.woff2";